import React from 'react';
import Icon from 'icon';

import s from '../form-input.module.scss';

export default function FormSelect({
  className,
  required,
  error: initialError,
  id,
  white,
  children,
  light,
  noMask,
  value: initialValue,
  state,
  ...props
}) {
  const value =
    state && props.name ? state.inputs[props.name] || '' : initialValue;
  const error = state && props.name ? state.errors[props.name] : initialError;
  return (
    <div
      className={`${s.root} ${s.select} ${className || ''} ${
        error ? s.error : ''
      } ${white ? s.white : ''} ${light ? s.light : ''}`}
    >
      {!noMask && (
        <div className={s.selectOverlay}>
          <Icon icon="caret" className={s.caret} />
        </div>
      )}
      <label htmlFor={id}>
        <select
          id={id}
          className={white ? s.white : ''}
          value={value}
          {...props}
        >
          {children}
        </select>
      </label>
    </div>
  );
}
